export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? "";

export const DEFAULT_ZOOM = 16;
export const DEFAULT_CENTER = { lat: 35.681236, lng: 139.767125 };
